import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JeeMainsLinkComponent } from './jee-mains-link/jee-mains-link.component';

const routes: Routes = [
  {path:'JEEMainVerification',component:JeeMainsLinkComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JeeMainsHallTicketVerificationRoutingModule { }
